module.exports = __webpack_public_path__ + "img/superintendencia.8a5c3f03.png";